var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbhLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 61.36547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cbh_logo_svg2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brand-mark"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "24.766 32.556 29.598 37.388 29.598 34.947 25.986 31.335 24.766 32.556",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.598 31.667 29.598 27.672 27.6 29.669 29.598 31.667",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.341 23.928 31.868 25.401 31.868 27.841 35.781 23.928 31.868 20.015 31.868 22.455 33.341 23.928",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.023 41.092 37.382 42.732 31.868 37.218 31.868 39.658 37.382 45.172 41.463 41.092 31.868 31.498 31.868 33.938 39.023 41.092",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18591,27.09058,20.18612,11.09035l9.41157,9.41158V18.06167L20.18612,8.65009,1.74565,27.09058,21.786,47.131,12.907,56.01c.47669.34.96057.67039,1.457.98327L24.22628,47.131Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.247 46.893 31.868 48.272 31.868 50.712 35.687 46.893 31.868 43.075 31.868 45.515 33.247 46.893",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.617 26.823 17.323 25.116 23.069 30.861 29.598 24.333 29.598 23.506 20.187 14.096 16.127 18.156 22.972 25.001 24.193 23.781 18.568 18.156 20.187 16.536 27.571 23.919 23.069 28.421 17.323 22.676 13.176 26.823 29.598 43.244 29.598 40.804 15.617 26.823",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.846 58.294 23.066 59.514 29.598 52.983 29.598 50.542 21.846 58.294",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.69027,34.40567,31.86843,54.22751v2.44027L51.69027,36.84594l1.68014,1.68015-21.502,21.502v1.65467c.27557-.01.55074-.02158.82441-.03882L55.81067,38.52609Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.489 58.29 29.598 60.399 29.598 56.181 27.489 58.29",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75723,47.16794.22284,34.63355q.1761,1.48864.49091,2.93117L11.53708,48.38808Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.06069,29.88568l1.22014,1.22012,5.74141-5.74138L59.1785,38.52068,56.27722,41.422l2.38669,2.38666q.38829-.84413.72426-1.716l-.67069-.67069,1.39786-1.39787c.2402-.78166.44229-1.57955.62043-2.38643L46.02224,22.92415Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.54737,45.99546,45.73568,57.80715A30.86272,30.86272,0,0,0,57.54737,45.99546Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5875,43.07078,36.49464,61.16367a30.52416,30.52416,0,0,0,3.24178-.80155l16.0712-16.0712Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.93879,61.15716c.70682.1349,1.42012.25092,2.14319.33654l-1.23987-1.23987Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86843,3.13162V5.57188l5.50219,5.50219L44.782,3.66273c-.54092-.27845-1.088-.5466-1.647-.7933L37.37062,8.63381Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86843,8.77035v2.44026l5.54314,5.54314L48.35114,5.81419q-.72084-.505-1.4718-.9685l-9.46777,9.4678Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59769,12.30218,19.62882,2.33331c-.57985.22469-1.14818.47168-1.71037.72989L29.59769,14.74244Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59769,6.49961,24.08639.98831c-.65563.14453-1.30159.31387-1.94075.49951l7.45205,7.45206Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59769.86088l-.542-.542c-.75484.04072-1.50372.103-2.24312.19715l2.78509,2.78509Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.07378,4.55659a30.87129,30.87129,0,0,0-9.63512,8.9893l.32291.32291Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.048 23.876 33.288 29.636 40.222 36.571 45.942 30.851 47.595 32.504 41.954 38.145 43.174 39.366 50.035 32.504 45.942 28.411 40.222 34.13 35.728 29.636 41.489 23.876 31.868 14.256 31.868 16.696 39.048 23.876",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47649,6.84883,17.25637,5.62869,5.72177,17.16329,4.143,15.58451q-.45157.77733-.85655,1.58372l2.43532,2.43532Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1195,20.06232l-1.62869-1.62867L51.54225,8.38221c-.42429-.39047-.86207-.766-1.30787-1.1324L39.05057,18.43365l4.0713,4.07132,2.87488-2.88678L61.21754,34.839c.09234-.73794.16644-1.48154.20546-2.2348L45.99436,17.17554Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73566,14.35261l-1.22012,1.22012,6.6868,6.6868A30.47385,30.47385,0,0,0,58.755,18.3719Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.32126,11.30321q-.55477-.6636-1.14624-1.294L47.6212,15.563,61.42244,29.36422c-.04758-.9133-.13919-1.81464-.26482-2.70508L50.06146,15.563Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.59769,47.48712V46.7574L9.92612,27.0858l5.79118-5.79116L14.49716,20.0745l-7.0113,7.0113,20.0373,20.03732-4.63269,4.641-6.43035,6.43035c.53732.28226,1.082.552,1.63748.80278l6.0136-6.01359Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.491,47.14976.09173,28.724C.03715,29.4724,0,30.22566,0,30.988c0,.02968.00211.05882.0022.08848L16.0515,47.149l-4.54719,4.54719L2.182,42.36045A30.598,30.598,0,0,0,4.7247,47.34863l6.77881,6.78858Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2587,19.41838c-.23807.585-.455,1.18046-.65744,1.78282l.078.078-.15617.15617a30.46936,30.46936,0,0,0-.89,3.33031l3.48648-3.48648Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.67418,1.91429c-.61392-.20972-1.23528-.40293-1.866-.57421l-1.4848,1.48479L35.07707.57859Q33.74356.3898,32.37548.31726l4.94787,4.94788Z",
    transform: "translate(0 -0.31726)",
    fill: "#00bff3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "brand-name"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.29805,31.43359h5.186c2.49854,0,4.3042,1.38575,4.3042,3.7793a3.46994,3.46994,0,0,1-1.84766,3.19141v.042a3.57114,3.57114,0,0,1,2.43555,3.59082c0,2.792-2.1626,4.21973-4.76611,4.21973h-5.312Zm5.186,6.23633a2.1,2.1,0,0,0,2.1836-2.24707,2.04075,2.04075,0,0,0-2.22559-2.18359H73.37666v4.43066Zm.231,6.78125a2.35406,2.35406,0,0,0,2.54053-2.51953,2.40839,2.40839,0,0,0-2.56153-2.541H73.37666v5.06055Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37617,31.43359h4.53516a7.48844,7.48844,0,0,1,2.77148.33594,4.05848,4.05848,0,0,1,2.499,4.00977,4.067,4.067,0,0,1-2.667,4.01074v.042a4.35745,4.35745,0,0,1,.44141.67188l3.14941,5.75293H94.7541l-3.1289-5.89942H88.45479v5.89942H86.37617Zm5.06006,7.11719a2.46506,2.46506,0,0,0,2.62451-2.6875A2.42568,2.42568,0,0,0,92.885,33.5752a4.08435,4.08435,0,0,0-2.03662-.33594H88.45479v5.31152Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.09687,41.99414h-5.585l-1.46972,4.2627h-2.1416l5.333-14.82325h2.1836l5.333,14.82325h-2.16211Zm-2.792-8.52344s-.33593,1.34375-.58789,2.09961l-1.65918,4.70313H108.551l-1.6377-4.70313c-.25195-.75586-.56738-2.09961-.56738-2.09961Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.84687,31.43359H118.926V46.25684h-2.07911Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.88887,31.43359h2.05761l6.59278,9.63672c.5459.79883,1.23828,2.14258,1.23828,2.14258h.043s-.14746-1.32324-.14746-2.14258V31.43359h2.0791V46.25684H134.715l-6.61328-9.61622c-.54688-.81835-1.23926-2.1621-1.23926-2.1621h-.042s.14648,1.32226.14648,2.1621v9.61622h-2.07812Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07539,31.49609h1.44824v6.71875H153.09V31.49609h1.44922V46.25684H153.09V39.51758h-8.56641v6.73926h-1.44824Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85469,31.49609h8.31445v1.30274h-6.86621v5.375h5.60644v1.30078h-5.60644v5.48047h7.24414v1.30176h-8.69238Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.16035,41.55371H174.218l-1.67969,4.70313H171.006l5.416-14.76075h1.55469l5.416,14.76075h-1.53222Zm-2.98242-8.52441s-.31445,1.21777-.56641,1.91015l-1.97363,5.3545H179.719l-1.93165-5.3545c-.25195-.69238-.5664-1.91015-.5664-1.91015Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.02852,31.49609h1.44824v13.459h6.8457v1.30176h-8.29394Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.99336,32.79883h-5.31152V31.49609h12.05078v1.30274h-5.291v13.458h-1.44824Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26289,31.49609h1.44824v6.71875h8.56641V31.49609h1.44922V46.25684h-1.44922V39.51758h-8.56641v6.73926h-1.44824Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1125,53.19141H71.29023v-.44727h4.13428v.44727H73.60957v4.61621H73.1125Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.80537,52.74414h.49707v2.30469h2.93848V52.74414H80.738v5.06348h-.49707V55.49609H77.30244v2.31153h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.80342,52.74414H85.655v.44727H83.3v1.84375h1.92334v.44629H83.3v1.87988h2.48486v.44629H82.80342Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8957,52.74414h.50391v3.292a1.43717,1.43717,0,0,0,2.87353-.01465V52.74414h.49707V56.043a1.93928,1.93928,0,0,1-3.87451,0Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83613,52.74414h.48242l2.58594,3.64453c.17188.252.417.68457.417.68457h.01465s-.043-.418-.043-.68457V52.74414h.49707v5.06348h-.48339l-2.585-3.64453c-.17285-.252-.418-.6836-.418-.6836h-.01465s.04394.417.04394.6836v3.64453h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7834,52.74414h.49707v5.06348h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7209,52.74414h.53222l1.4043,3.84668c.09375.25879.19434.65527.19434.65527h.01465s.10058-.39648.19433-.65527l1.4043-3.84668h.5332l-1.87988,5.06348h-.51856Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.40742,52.74414H112.26v.44727h-2.35547v1.84375h1.92285v.44629h-1.92285v1.87988h2.48438v.44629h-2.98145Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.10957,52.74414h1.498a2.2424,2.2424,0,0,1,.95117.1377,1.47364,1.47364,0,0,1-.19434,2.67187v.01367a2.12777,2.12777,0,0,1,.12891.20215l1.10254,2.03809h-.56934l-1.14551-2.13184h-1.27441v2.13184h-.49707Zm1.7002,2.48535a1.04856,1.04856,0,0,0,.54-1.916,1.45832,1.45832,0,0,0-.7207-.12207h-1.02246v2.03808Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.14961,56.86426a1.97756,1.97756,0,0,0,1.32519.55469.91332.91332,0,0,0,1.00879-.87891c0-1.27442-2.52832-.95117-2.52832-2.52051a1.45627,1.45627,0,0,1,1.57715-1.36133,1.96681,1.96681,0,0,1,1.35449.48926l-.24511.418a1.72742,1.72742,0,0,0-1.10938-.43164.96842.96842,0,0,0-1.06543.87109c0,1.20313,2.52735.85742,2.52735,2.52051a1.3959,1.3959,0,0,1-1.53418,1.36816,2.23012,2.23012,0,0,1-1.60547-.64746Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65742,52.74414h.49707v5.06348h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.31465,53.19141h-1.82129v-.44727h4.13379v.44727h-1.81543v4.61621h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18965,55.63281l-1.707-2.88867h.56836l1.07324,1.83691c.15137.25977.30957.60547.30957.60547h.01465s.15136-.33886.30957-.60547l1.07324-1.83691h.56152l-1.69922,2.88867v2.17481h-.5039Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5334,52.6582a2.55954,2.55954,0,0,1,2.5791,2.585,2.57959,2.57959,0,1,1-5.15723,0A2.55933,2.55933,0,0,1,140.5334,52.6582Zm0,4.77442a2.10871,2.10871,0,0,0,2.06055-2.18946,2.061,2.061,0,1,0-4.12012,0A2.10425,2.10425,0,0,0,140.5334,57.43262Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.79609,52.74414h2.665v.44727h-2.168v1.90136h1.8584v.44629h-1.8584v2.26856h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.69551,53.19141h-1.82227v-.44727H155.007v.44727H153.1916v4.61621h-.49609Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35176,52.74414h2.85254v.44727h-2.35547v1.84375h1.92285v.44629h-1.92285v1.87988h2.48535v.44629h-2.98242Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.12715,55.16406l-1.46973-2.41992h.584l.88574,1.498c.15137.25976.33105.584.33105.584h.01465a5.83572,5.83572,0,0,1,.30274-.584l.89257-1.498h.59082l-1.48339,2.41992,1.62011,2.64356h-.57617l-1.05176-1.75c-.1582-.25977-.3164-.56153-.3164-.56153h-.01465s-.15137.30176-.30957.56836L161.09,57.80762h-.57617Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.42012,56.19434H166.382l-.57617,1.61328h-.52539l1.8584-5.06348h.53222l1.8584,5.06348h-.52539Zm-1.02246-2.92383s-.1084.418-.19434.65527l-.67676,1.83692h1.74317l-.66309-1.83692c-.08691-.2373-.19434-.65527-.19434-.65527Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8752,56.86426a1.97457,1.97457,0,0,0,1.32519.55469.91332.91332,0,0,0,1.00879-.87891c0-1.27442-2.52832-.95117-2.52832-2.52051A1.45626,1.45626,0,0,1,172.258,52.6582a1.96684,1.96684,0,0,1,1.35449.48926l-.24512.418a1.72741,1.72741,0,0,0-1.10937-.43164.96842.96842,0,0,0-1.06543.87109c0,1.20313,2.52734.85742,2.52734,2.52051a1.3959,1.3959,0,0,1-1.53418,1.36816,2.23012,2.23012,0,0,1-1.60547-.64746Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4582,56.19434h-2.03808l-.57617,1.61328h-.5254l1.8584-5.06348h.53223l1.8584,5.06348h-.52539Zm-1.02246-2.92383s-.10742.418-.19433.65527l-.67676,1.83692h1.74219l-.66211-1.83692c-.08594-.2373-.19434-.65527-.19434-.65527Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.11543,53.19141h-1.82129v-.44727h4.13379v.44727H184.6125v4.61621h-.49707Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.343,52.74414h1.63476a2.53176,2.53176,0,1,1,0,5.06348H190.343Zm1.585,4.61719a2.085,2.085,0,0,0,0-4.16992H190.84v4.16992Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.73945,56.19434h-2.03808l-.57617,1.61328h-.5254l1.8584-5.06348h.53223l1.8584,5.06348h-.52539ZM197.717,53.27051s-.10742.418-.19433.65527l-.67676,1.83692h1.74219l-.66211-1.83692c-.08594-.2373-.19434-.65527-.19434-.65527Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3166,52.74414h.49707v4.61719h2.34766v.44629H201.3166Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.594,52.74414h.49707v4.61719h2.34765v.44629H205.594Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.36934,56.19434h-2.03809l-.57617,1.61328h-.52539l1.8584-5.06348h.53222l1.8584,5.06348h-.52539Zm-1.02247-2.92383s-.10839.418-.19433.65527l-.67676,1.83692H212.219l-.66309-1.83692c-.08691-.2373-.19434-.65527-.19434-.65527Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.90352,56.86426a1.97753,1.97753,0,0,0,1.32519.55469A.91332.91332,0,0,0,217.2375,56.54c0-1.27442-2.52832-.95117-2.52832-2.52051a1.45626,1.45626,0,0,1,1.57715-1.36133,1.96684,1.96684,0,0,1,1.35449.48926l-.24512.418a1.72741,1.72741,0,0,0-1.10937-.43164.96842.96842,0,0,0-1.06543.87109c0,1.20313,2.52734.85742,2.52734,2.52051a1.3959,1.3959,0,0,1-1.53418,1.36816,2.23012,2.23012,0,0,1-1.60547-.64746Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72773,15.60352a4.67878,4.67878,0,0,1,3.31641,1.19336l-.48486.668a4.33376,4.33376,0,0,0-2.80518-1.02246,3.68432,3.68432,0,0,0-3.70947,3.85352,3.79769,3.79769,0,0,0,3.73584,3.998,4.30859,4.30859,0,0,0,2.98828-1.23243l.52441.64258a4.91593,4.91593,0,0,1-3.52587,1.42871,4.64,4.64,0,0,1-4.66651-4.82324A4.57206,4.57206,0,0,1,75.72773,15.60352Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.55049,15.76074h5.19043v.81348H83.45479v3.35547h3.5v.8125h-3.5v3.4209h4.52246v.8125H82.55049Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32783,15.76074h.87793l4.70654,6.63281c.31446.459.75977,1.24512.75977,1.24512h.02637s-.07813-.75976-.07813-1.24512V15.76074h.9043v9.21485H97.6457l-4.70556-6.63184c-.31446-.459-.76075-1.24609-.76075-1.24609H92.154s.07813.76074.07813,1.24609v6.63184h-.9043Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.56074,16.57422h-3.3164v-.81348h7.52343v.81348H105.465v8.40137h-.9043Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.48945,15.76074h5.19043v.81348h-4.28613v3.35547h3.5v.8125h-3.5v3.4209h4.52246v.8125h-5.42676Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2668,15.76074h2.72656a4.09061,4.09061,0,0,1,1.72949.249,2.46042,2.46042,0,0,1,1.38965,2.373,2.463,2.463,0,0,1-1.74316,2.49024v.02636a3.63494,3.63494,0,0,1,.23632.36719l2.00489,3.709h-1.03516l-2.084-3.87989h-2.32032v3.87989h-.90429Zm3.09375,4.52246a1.721,1.721,0,0,0,1.82129-1.874,1.70688,1.70688,0,0,0-.83887-1.6123,2.64366,2.64366,0,0,0-1.31055-.22266h-1.86133v3.709Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05228,27.33046a4.01056,4.01056,0,0,0,1.26731-2.14073c.23988-1.77764.8056-5.43216.79295-5.53407-.42958,0-.92344.01465-1.35566.01465-.00792-.04664-.02836-.272-.03626-.31863.304.008.53628-.02789.85012-.0376.47684-.03177.64766-.2841.69943-.71912a5.99248,5.99248,0,0,1,.218-1.03241,3.05538,3.05538,0,0,1,2.74027-2.225,1.67658,1.67658,0,0,1,.62047.13829.55905.55905,0,0,1,.35928.70835.58689.58689,0,0,1-.68427.41692,1.30342,1.30342,0,0,1-1.05036-.85626c-.834.39439-1.20371,1.76463-1.35052,3.48808h1.42985l-.06788.4694c-.36748,0-.65259.011-1.063-.00919-.34959-.00545-.36383.07462-.40215.339-.2,1.3806-.42474,2.7576-.62986,4.13748a4.73188,4.73188,0,0,1-1.92419,3.13385c-.41143.31184-1.60116.98379-2.03332.20152a.47816.47816,0,0,1,.26575-.647C131.33141,26.51252,131.65639,26.60866,132.05228,27.33046Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.72017,21.4023a4.19455,4.19455,0,0,1-1.17978,2.85925,2.7094,2.7094,0,0,1-2.2474.83577,1.80912,1.80912,0,0,1-1.5905-1.38659,4.18217,4.18217,0,0,1,1.57074-4.27337,2.84257,2.84257,0,0,1,.96513-.40505C141.76566,18.72269,142.71563,19.58881,142.72017,21.4023Zm-1.35158-1.45139a1.08132,1.08132,0,0,0-1.90836-.21022,2.02133,2.02133,0,0,0-.27848.41973,5.26481,5.26481,0,0,0-.50526,3.07816,3.05209,3.05209,0,0,0,.23315.83542,1.09858,1.09858,0,0,0,1.96035.24407,2.15232,2.15232,0,0,0,.40609-.71253A6.08112,6.08112,0,0,0,141.36859,19.95091Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.67181,24.94036h-.89064c.14471-.86389.28455-1.704.42641-2.5437.1047-.61979.186-1.24516.32784-1.85641.08746-.37686-.05353-.47663-.36791-.69349-.13117-.09049-.28255-.153-.53237-.29212l2.00524-.66432-.104,1.04953a6.78034,6.78034,0,0,1,1.01166-.78145,1.85568,1.85568,0,0,1,.96263-.16379c.35446.029.5085.31458.44164.67581a.56164.56164,0,0,1-.62728.48286.85094.85094,0,0,1-.39532-.10041c-.25168-.14323-.47305-.33566-.7859-.11678a1.47578,1.47578,0,0,0-.789,1.0044c-.18251,1.24367-.40926,2.48085-.61938,3.72044C145.72053,24.749,145.696,24.83542,145.67181,24.94036Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.70963,41.41953a2.32681,2.32681,0,1,1-2.2585,2.32262A2.29529,2.29529,0,0,1,227.70963,41.41953Zm0,4.30588a1.98267,1.98267,0,1,0-1.88127-1.98326A1.92,1.92,0,0,0,227.70963,45.72541Zm-.75521-3.23082h.88945a.70688.70688,0,0,1,.74846.74209.6517.6517,0,0,1-.46685.65884v.01312a1.06429,1.06429,0,0,1,.08324.14062l.4796.94044h-.39673l-.49872-1.01094h-.48V44.9897h-.35848Zm.8257,1.20294a.41882.41882,0,0,0,.44135-.46085.40675.40675,0,0,0-.44135-.44135h-.46722v.9022Z",
    transform: "translate(0 -0.31726)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbhLogo);
export default __webpack_public_path__ + "static/media/cbh_logo.b8551dc1.svg";
export { ForwardRef as ReactComponent };